import { render, staticRenderFns } from "./PointModal.vue?vue&type=template&id=2a806880"
import script from "./PointModal.js?vue&type=script&lang=js&external"
export * from "./PointModal.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports